let cachedOptions = null;
let pendingPromise = null;

export async function fetchInstructionOptionsCached(backendService, planId) {
  if (cachedOptions) return cachedOptions;
  if (!pendingPromise) {
    pendingPromise = backendService.fetchInstructionOptions(planId);
  }
  cachedOptions = await pendingPromise;
  return cachedOptions;
}
